import { Link } from "react-router-dom";

const HotelNav = ({ selected }) => {
  const array = [
    {
      id: "hotel",
      name: "Manage Requests",
    },
    {
      id: "csv",
      name: "Generate Reports",
    },
    {
      id: "upload",
      name: "Upload Confirmations",
    },
    {
      id: "changes",
      name: "Pending Changes",
    },
  ];

  return (
    <nav style={{ marginTop: "0px" }}>
      {array.map((item) => {
        return (
          <Link
            key={item.id}
            className={
              item.id === selected ? "subpage-tab selected" : "subpage-tab"
            }
            to={
              item.id === "hotel" ? `/admin/hotel` : `/admin/hotel/${item.id}`
            }
          >
            {item.name}
          </Link>
        );
      })}
    </nav>
  );
};

export default HotelNav;
